<div class="flex-row justify-between items-start">
  <h2 mat-dialog-title>{{ 'generic.download' | translate }}</h2>
  <button mat-button class="close-icon" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>

<section class="checkbox-section">
  <mat-radio-group [formControl]="documentType">
    <mat-radio-button class="checkbox" value="pdf" [checked]="true">
      {{ 'generic.pdf' | translate | uppercase }}
    </mat-radio-button>
    @if (activityDownloadForm.get('type').value === 'material') {
      <mat-radio-button class="checkbox" value="excel">{{ 'generic.excel' | translate | titlecase }}</mat-radio-button>
    }
  </mat-radio-group>
</section>

@if (!loading) {
  <div mat-dialog-content [formGroup]="activityDownloadForm">
    <p>{{ 'download_activity_pdf_dialog.description' | translate: {activityName: activity?.name} }}</p>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'download_activity_pdf_dialog.type.label' | translate }}</mat-label>
      <mat-select formControlName="type">
        @for (typeOption of pdfOptions; track typeOption) {
          <mat-option
            [value]="typeOption.value"
            >
            {{ typeOption.label | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
@if (loading) {
  <div mat-dialog-content>
    <p>{{ 'download_activity_pdf_dialog.loading' | translate }}</p>
  </div>
}
<div mat-dialog-actions>
  <button mat-button [disabled]="loading" (click)="onNoClick()">{{ 'generic.cancel' | translate | uppercase }}</button>
  <div class="flex-row">
    <button
      mat-button
      color="primary"
      (click)="confirm()"
      [disabled]="activityDownloadForm.invalid || loading"
      cdkFocusInitial
      >
      {{ 'generic.ok' | translate }}
    </button>
    @if (loading) {
      <mat-progress-spinner diameter="30" color="primary" mode="indeterminate"></mat-progress-spinner>
    }
  </div>
</div>
